import {createApi} from '@reduxjs/toolkit/query/react';

import type {
  EventSoundResponse,
  EventSummaryResponse,
} from '../../../interfaces/Event';
import {axiosBaseQuery} from './axiosBaseQuery';

export const eventSummaryApi = createApi({
  reducerPath: 'eventSummaryApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getEventSummary: builder.query<EventSummaryResponse, void>({
      query: () => ({url: 'event/summary', method: 'get'}),
    }),
    getEventSound: builder.query<EventSoundResponse, void>({
      query: () => ({url: 'event/summary/sound', method: 'get'}),
    }),
  }),
});

export const {useGetEventSummaryQuery, useGetEventSoundQuery} = eventSummaryApi;
